module.exports = __webpack_public_path__ + "assets/img/img56.63f09ca8.png";